import { Info } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Fase R.8 (16/08/2026, sección 7): aviso responsable único y reutilizable -- se coloca en
 * recomendaciones, parlays, el Reto y onboarding/info, nunca como un bloque legal enorme en
 * cada pantalla. Texto fijo, nunca variable por pick (evita cualquier redacción que se lea
 * como garantía de resultado). */
export function ResponsibleNotice({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-xl bg-panel-elevated/40 border border-border/40 p-2.5 text-[10px] text-text-dim leading-snug',
        className
      )}
    >
      <Info className="h-3.5 w-3.5 shrink-0 mt-0.5 text-text-dim" />
      <span>
        Las selecciones de John Anthony son recomendaciones basadas en modelos estadísticos y datos
        disponibles. Ningún pronóstico garantiza un resultado.
      </span>
    </div>
  )
}
